import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { useMemo } from 'react';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useLocale from 'hooks/useLocale';

import AppLogger from 'utils/AppLogger';

import * as S from './DownloadShippingStickersModal.styled';

/**
 * @author @buunsal
 */

const StickersData = {
	arabicValue: [
		{
			url: 'https://storage.googleapis.com/tryoto-public/stickers/cold-ar.png',
			name: 'cold-ar',
			label: 'cold'
		},
		{
			url: 'https://storage.googleapis.com/tryoto-public/stickers/fragile-ar.png',
			name: 'fragile-ar',
			label: 'fragile'
		}
	],
	trValue: [
		{
			url: 'https://storage.googleapis.com/tryoto-public/stickers/cold-tr.png',
			name: 'cold-tr',
			label: 'cold'
		},
		{
			url: 'https://storage.googleapis.com/tryoto-public/stickers/fragile-tr.png',
			name: 'fragile-tr',
			label: 'fragile'
		}
	]
};

export const DownloadShippingStickersModal = NiceModal.create(() => {
	const modal = useModal();
	const { LanguageCode } = useLocale();
	const stickers = useMemo(() => StickersData[LanguageCode] ?? StickersData.arabicValue, [LanguageCode]);

	return (
		<Modal fullwidth maxWidth="small" className="modal-downloadShippingStickers">
			<ModalTitle>
				<Typography variant="p1">downloadStickers</Typography>
			</ModalTitle>

			<ModalContent style={{ width: '100%', height: '100%' }}>
				<S.StickersContainer>
					{stickers.map(({ url, name, label }) => (
						<S.Sticker key={name}>
							<Image url={url} width="8rem" height="8rem" />
							<Typography variant="p2">{`shippingSticker.${label}`}</Typography>
							<div style={{ flex: 1 }} />
							<Button
								variant="blueBorderless"
								label="download"
								onClick={() => {
									fetch(url, {
										method: 'GET',
										headers: {}
									})
										.then((response) => {
											response.arrayBuffer().then((buffer) => {
												const url = window.URL.createObjectURL(new Blob([buffer]));
												const link = document.createElement('a');
												link.href = url;
												link.download = `${name}.png`;
												document.body.appendChild(link);
												link.click();
											});
										})
										.catch((error) => {
											AppLogger.log(error);
										});
								}}
								css={css`
									text-decoration: underline;

									> .button-text {
										font-weight: 500;
									}
								`}
							/>
						</S.Sticker>
					))}
				</S.StickersContainer>
			</ModalContent>

			<ModalActions>
				<Button
					variant="blackOutline"
					label="cancel"
					onClick={modal.remove}
					css={css`
						text-decoration: underline;
						border: none !important;
					`}
				/>
			</ModalActions>
		</Modal>
	);
});

export default DownloadShippingStickersModal;
